export default "__VITE_ASSET__DR183xnS__"